import Vue from "vue";
import axios from 'axios'
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "../css/iconfont/iconfont.css";
import store from "./store/store";
// import api from "@/api/onlineSchool";
// import subApi from "@/api/subApi";
// import liveUser from "@/api/liveUser";
import defaultApi from './utils/defaultApi'
import common from "./utils/common";
// import commApiRequest from "@/api/commApiRequest";
import "./style/element-variables.scss";
import "../css/Media.css";
import "./router/permission";
import "./assets/font/iconfont.css";
import initSystemAxiosInstance from './api/index'
import GLOBAL_CONFIG from '../config/index'

// 正式环境根据设备类型 跳转终端
if (process.env.NODE_ENV !== "development") {
  common.checkEquipment("pc");
}
Vue.use(ElementUI);
// Vue.prototype.$axios = api;
// Vue.prototype.$subApi = subApi;
// Vue.prototype.$liveUser = liveUser;
// Vue.prototype.$liveApi =  commApiRequest(process.env.VUE_APP_API_ROOT)
// Vue.prototype.$onlineApi = commApiRequest(process.env.VUE_APP_API_ONLINE)
Vue.directive("focus", {
  bind(el) {
    el.focus();
  },
});

Vue.config.productionTip = false;

// https://shkt-online-live-1317978474.cos.accelerate.myqcloud.com/web/config/requestApi/default.json
axios.get(`${GLOBAL_CONFIG.platformDefaultConfigDomain}/web/config/requestApi/default.json?a=${new Date().valueOf()}`).then(({ status, data }) => {
  if (status === 200 && data) {
    getBaseUrl(data)
  }
  renderPage()
}).catch((error) => {
  getBaseUrl()
  renderPage()
})

function getBaseUrl(setting) {
  if (!setting) {
    setting = defaultApi
  }
  const { SHANHU_LIVE_API, SHANHU_DATA_API, SHANHU_ONLINE_API, SHANHU_LIVE_HY_API } = setting
  Vue.prototype.SHANHU_LIVE_API = SHANHU_LIVE_API
  Vue.prototype.SHANHU_DATA_API = SHANHU_DATA_API
  Vue.prototype.SHANHU_ONLINE_API = SHANHU_ONLINE_API
  Vue.prototype.SHANHU_LIVE_HY_API = SHANHU_LIVE_HY_API
  initSystemAxiosInstance()
}

function renderPage() {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

// new Vue({
//   router,
//   store,
//   render: (h) => h(App),
// }).$mount("#app");
